import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-text-input-dialog',
  templateUrl: './text-input-dialog.component.html',
})
export class TextInputDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      placeholder: string;
      value?: string;
    },
  ) {
    this.formControl.setValue(data.value || '');
  }

  public formControl = new FormControl();
}
